import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
    selector: 'topo-vertical-tabs',
    templateUrl: './vertical-tabs.component.html',
    styleUrls: ['./vertical-tabs.component.scss'],
    standalone: false
})
export class VerticalTabsComponent {
  private _selectedTabIndex = 0;
  @Input()
  public set selectedTabIndex(value) {
    this._selectedTabIndex = value;
    this.updateTabModel();
  }
  private _tabs: string[] = [];
  @Input()
  public set tabs(value: string[]) {
    this._tabs = value;
    this.updateTabModel();
  }
  private _disabledTabs: number[] = [];
  @Input()
  public set disabledTabs(value: number[]) {
    this._disabledTabs = value;
    this.updateTabModel();
  }
  @Output() selectedTabIndexChanged = new EventEmitter<number>();

  public tabsModel: { value: number, name: string, disabled: boolean, selected: boolean }[] = [];

  constructor() {}
  updateTabModel() {
    this.tabsModel = this._tabs.map((v, i, a) => {
      return { value: i, name: v, disabled: !!this._disabledTabs.find(ii => ii === i), selected: this._selectedTabIndex === i
      } as { value: number, name: string, disabled: boolean, selected: boolean };
    });
  }

  tabClick(index): void {
    if (this._disabledTabs?.findIndex(dt => dt === index) >= 0) {
      return;
    }

    this._selectedTabIndex = index;
    this.selectedTabIndexChanged.emit(this._selectedTabIndex);
  }
}
